export default __webpack_public_path__ + "static/media/image-study-board-2-m@3x.027123e9.webp";